/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const messageCaseStyle = {
  headline: {
    display: "flex",
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: "space-between",
    alignItems: {
      xs: "flex-start",
      sm: "baseline",
    },
  },
  unreadConversation: {
    display: "flex",
    width: "100%",
    gap: "0.75rem",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
    color: "inherit",
    borderBottom: "1px solid",
    borderColor: "divider",
    padding: "1rem 0",
  },
  subject: {
    flexGrow: 1,
    minWidth: 0,
  },
  date: {
    whiteSpace: "nowrap",
  },
  actions: {
    justifyContent: "flex-end",
    marginTop: "1rem",
  },
  openButton: {
    width: {
      xs: "100%",
      sm: "12rem",
    },
  },
};
